// Persistent visitor color. Hash the visitor id into one of a small set of
// muted, editorial-compatible hues — same visitor always gets the same color,
// across sessions and across agents/admin, with no DB column or persistence.
//
// Palette picked to play nicely with the oxide-red accent and the warm
// paper/ink neutrals — no clashes, no saturated primaries.

const PALETTE: ReadonlyArray<string> = [
  '#7A5B3A', // tan
  '#5D7A4A', // moss
  '#476275', // steel blue
  '#7A4D5C', // mulled wine
  '#3F6F6C', // teal
  '#8C6B3D', // amber
  '#4F5571', // dusk
  '#7E3F3F', // brick
  '#506041', // olive
  '#6B4A6E', // plum
];

/** Stable color for a given visitor id. Returns a hex string. */
export function colorForVisitor(visitorId: string): string {
  let h = 5381;
  for (let i = 0; i < visitorId.length; i++) {
    h = ((h << 5) + h + visitorId.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(h) % PALETTE.length;
  return PALETTE[idx]!;
}
